import React from 'react';
import PlayerInventory from '../../components/PlayerInventory';
import { useApiGet } from '../../../common/services/api';
import PlayerProfessions from '../../components/PlayerProfessions';
import levelTransformer from '../../../game/transformers/level';
import userTransformer from '../../transformers/userTransformer';
import PlayerDashboardHeader from '../PlayerDashboardHeader';
import ApiResult from '../../components/ApiResult';

const PlayerDashboard = ({ userId, ...headerProps }) => {
  const id = userId || '';
  const { response: user, isLoading: userLoading, error: userError } = useApiGet({
    url: `users/${id}`,
    transformer: userTransformer,
  });
  const {
    response: collectibles,
    isLoading: collectiblesLoading,
    error: collectiblesError,
  } = useApiGet({
    url: `users/${id}/collectibles`,
  });
  const { response: allLevels = [], isLoading: levelsLoading, error: levelsError } = useApiGet({
    url: 'levels',
    transformer: levelTransformer,
  });
  const { inventory, professions, totals = {} } = collectibles || {};

  return (
    <>
      <PlayerDashboardHeader error={userError} loading={userLoading} user={user} {...headerProps} />

      <ApiResult
        error={collectiblesError || levelsError}
        loading={collectiblesLoading || levelsLoading}
        render={() => (
          <>
            <PlayerInventory totals={totals} inventory={inventory} levels={allLevels} />
            <PlayerProfessions totalProfessions={totals.professions} professions={professions} levels={allLevels} />
          </>
        )}
      />
    </>
  );
};

export default PlayerDashboard;
